











import Header from '@/components/Header.vue';
import { Template } from '@/types/Template';
import { Video } from '@/types/Video';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Video',
    components: {
        Header,
    },
    computed: {
        ...mapGetters(['videos', 'templates']),
        video(): Video {
            return this.videos.find((video: Video) => video.id.toString() === this.$route.params.id);
        },
        template(): Template {
            return this.templates.find((template: Template) => template.id === this.video.template.id);
        },
    },
});
